import {
    AR_LOCALE,
    AU_LOCALE,
    BE_LOCALE,
    BR_LOCALE,
    CA_LOCALE,
    DE_LOCALE,
    GB_LOCALE,
    IE_LOCALE,
    NL_LOCALE,
    US_LOCALE,
} from '@eb/intl';

// janus checkpoints
export const SIGN_IN_HEADER_CLICKED = 'sign_in_header_clicked';
export const OVERVIEW_HEADER_CLICKED = 'overview_header_clicked';
export const PRICING_HEADER_CLICKED = 'pricing_header_clicked';
export const CONTACT_HEADER_CLICKED = 'contact_header_clicked';
export const BLOG_HEADER_CLICKED = 'blog_header_clicked';
export const SUCCESS_STORIES_HEADER_CLICKED = 'success_stories_header_clicked';
export const PRODUCT_DEMO_HEADER_CLICKED = 'product_demo_header_clicked';
export const EVENT_GUIDES_HEADER_CLICKED = 'event_guides_header_clicked';

// Header Analytics
export const GA_ACTION_PRICING = 'Pricing';
export const GA_ACTION_RESOURCES_BLOG = 'ResourcesBlog';
export const GA_ACTION_RESOURCES_SUCCESS_STORIES = 'ResourcesSuccessStories';
export const GA_ACTION_RESOURCES_PRODUCT_DEMO = 'ResourcesProductDemo';
export const GA_ACTION_RESOURCES_EVENT_GUIDE = 'ResourcesEventGuide';
export const GA_ACTION_CONTACT_SALES = 'Contact';
export const GA_ACTION_SIGNIN = 'Signin';
export const CATEGORY_ORGANIZER_MARKETING_HEADER = 'org-marketing-header';
export const LABEL_HELP_CENTER = 'HelpCenter';
export const GA_ACTION_PROFILE_DROPDOWN = 'ProfileDropdown';
export const GA_CATEGORY_HEADER = 'header';
export const GA_LABEL_CREATOR_EVENT = 'ViewFromConsumer';

// Locale
export const LOCALE_SPECIFIC_URLS = {
    [AR_LOCALE]: {
        blogLink: '/blog/',
        successStoriesLink: '/blog/category/casos-de-exito/',
        productDemoLink:
            '/blog/eventbrite-para-eventos/como-funciona-eventbrite/',
        eventGuidesLink: '/blog/category/eventbrite-para-eventos/',
    },
    [AU_LOCALE]: {
        blogLink: '/blog/',
        successStoriesLink: '/blog/case-studies/',
        productDemoLink: '/blog/academy/on-demand-demo/',
        eventGuidesLink: '/blog/academy',
    },
    [BE_LOCALE]: {
        blogLink: 'https://www.eventbrite.nl/blog/',
    },
    [BR_LOCALE]: {
        blogLink: '/blog/',
        successStoriesLink: '/blog/case-studies/',
        productDemoLink: '/blog/onde-comecar/demo-completa-da-eventbrite/',
        eventGuidesLink: '/blog/academy/',
    },
    [CA_LOCALE]: {
        blogLink: 'https://www.eventbrite.com/blog/',
        successStoriesLink: 'https://www.eventbrite.com/blog/case-studies/',
        productDemoLink:
            'https://www.eventbrite.com/blog/webinar/on-demand-eventbrite-demo/',
        eventGuidesLink: 'https://www.eventbrite.com/blog/academy/',
    },
    [DE_LOCALE]: {
        blogLink: '/blog/',
        successStoriesLink: '/blog/category/case-studies',
        productDemoLink: '/support/GettingStarted?lg=de',
        eventGuidesLink: '/blog/category/profi-tipps/',
    },
    [GB_LOCALE]: {
        blogLink: '/blog/',
        successStoriesLink: '/blog/case-studies/',
        productDemoLink: '/blog/eventbrite-on-demand-webinar',
        eventGuidesLink: '/blog/content-type/guide/',
    },
    [IE_LOCALE]: {
        blogLink: '/blog/',
    },
    [NL_LOCALE]: {
        blogLink: 'https://www.eventbrite.nl/blog/',
    },
    [US_LOCALE]: {
        blogLink: '/blog/',
        successStoriesLink: '/blog/case-studies/',
        productDemoLink: '/blog/webinar/on-demand-eventbrite-demo',
        eventGuidesLink: '/blog/academy',
    },
};
